var $65a71f9a56f1398f$exports = {};
$65a71f9a56f1398f$exports = {
    "dropzoneLabel": `\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{30BE}\u{30FC}\u{30F3}`,
    "selectPlaceholder": `\u{9805}\u{76EE}\u{3092}\u{9078}\u{629E}`,
    "tableResizer": `\u{30B5}\u{30A4}\u{30BA}\u{5909}\u{66F4}\u{30C4}\u{30FC}\u{30EB}`
};


export {$65a71f9a56f1398f$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
